import { API_BASE_URL } from "@/api/api.config";
import { IMPLEMENTATION_GUIDE_API_BASE_URL } from "@/components/ImplementationGuide/constants";
import {
  FormSlug,
  ImplementationGuideFormData,
} from "@/components/ImplementationGuide/types";
import useRestQuery from "@/remoteState/useRestQuery";

const useImplementationGuideSummaryGet = (districtUniqueId: string) => {
  const fullImplementationGuideApiUrl = `${API_BASE_URL}${IMPLEMENTATION_GUIDE_API_BASE_URL}${districtUniqueId}/summary/`;

  return useRestQuery<Record<FormSlug, ImplementationGuideFormData>>(
    fullImplementationGuideApiUrl,
    { skip: !districtUniqueId },
  );
};

export default useImplementationGuideSummaryGet;
